import { api } from 'api/axios';

import urls from 'engine/urls';

export const getContractorNipValidation = (nip) => api.get(urls().ValidateNIP, { params: { nip } });

export const validateNIP = async (nip) => {
  if (nip) {
    try {
      const response = await getContractorNipValidation(nip);
      if (response.result) {
        return true;
      }
    } catch (error) {
      // console.log(error)
    }
  }

  return false;
};
